module.exports = __webpack_public_path__ + "img/lj.b6d0d034.png";